import { SegmentoTela } from "./segmento.model";

export class ArquivoBinario {
    idArquivoBinario: number | undefined;
    idTipoArquivo: number;
    arquivoBinario: string;
    nomeArquivoBinario: string;
    textoArquivoBinario: string;
    posicaoArray: number;
    segmento: SegmentoTela;
    mensagemErro: string;
    tamanho: number;
    conteudoTabela: string;
}
